// extracted by mini-css-extract-plugin
export var externalLinkButton = "ExternalLinkButton-module--externalLinkButton--cdb97 typography-module--bodyLarge--e3996";
export var externalLinkButtonWrapper = "ExternalLinkButton-module--externalLinkButtonWrapper--4d786";
export var externalLinkCaption = "ExternalLinkButton-module--externalLinkCaption--f9970";
export var text = "ExternalLinkButton-module--text--1caf6";
export var webIcon = "ExternalLinkButton-module--webIcon--58364";